<template>
  <div class="info-header">
    <div class="tabs">
      <div
        class="tab"
        v-for="tab in tabs"
        :key="tab.name"
        :class="{ active: params.category === tab.name }"
        @click="onTabClick(tab)"
      >
        {{ tab.text }}
      </div>
    </div>
    <a-input-search
    class="search"
      v-model="keyword"
      :style="{ width: '240px' }"
      @search="onSearch"
      @press-enter="onSearch"
      @clear="onSearch"
      placeholder="搜索"
      allow-clear
    />
  </div>
</template>
<script lang="ts" setup>
const tabs = [
  { name: 'news', text: '海外动态' },
  { name: 'guide', text: '出海攻略' },
  { name: 'policy', text: '政策指南' },
];
const { params } = useRoute();

async function onTabClick(tab: typeof tabs[0]) {
  await navigateTo({ path: `/info/${tab.name}` });
}

const route = useRoute();
const keyword = ref(route.query.keyword || '');
const emit = defineEmits(['search']);
function onSearch() {
  emit('search', keyword.value);
}
</script>
<style lang="less" scoped>
@media screen and(min-width:800px) {
  .info-header {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e7eb;
    box-sizing: border-box;
    height: 60px;
    justify-content: space-between;
    .tabs {
      height: 100%;
      display: flex;
      .tab {
        padding: 0 60px;
        font-size: 20px;
        line-height: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        &:hover {
          color: #386aff;
        }
        &.active {
          color: #386aff;
          font-weight: 500;
          background: rgba(22, 93, 255, 0.1);
          &:after {
            content: " ";
            display: block;
            position: absolute;
            height: 3px;
            bottom: 0;
            width: 100%;
            background: #165dff;
          }
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
@media screen and(max-width:800px) {
  .info-header {
    position: sticky;
    top: 70px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e5e7eb;
    box-sizing: border-box;
    height: 40px;
    justify-content: space-between;
    background-color: #fff;
    .tabs {
      height: 100%;
      display: flex;
      gap: 24px;
      .tab {
        padding: 0 12px;
        font-weight: 500;
        font-size: 14px;
        line-height: 28px;
        letter-spacing: 0.02em;
        white-space: nowrap;
        color: #4E5969;

        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        cursor: pointer;
        &:hover {
          color: #386aff;
        }
        &.active {
          color: #386aff;
          font-weight: 500;
          background: rgba(22, 93, 255, 0.1);
          &:after {
            content: " ";
            display: block;
            position: absolute;
            height: 3px;
            bottom: 0;
            width: 100%;
            background: #165dff;
          }
        }
      }
    }
    .search {
      display: none;
    }
  }
}
</style>
